<template>
  <v-container class="allibo-joblist-container" v-if="jobs && !loading">
    <v-row class="allibo-filters">
      <v-col cols="12" sm="4" md="4" xl="4" v-if="availableJobTypes">
        <v-select
          :items="availableJobTypes"
          v-model="selectedType"
          @change="filterJobs"
          label="RUOLO"
          class="allibo-filter-job-type"
          filled
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4" md="4" xl="4">
        <v-select
          :items="availableJobTimes"
          v-model="selectedTime"
          @change="filterJobs"
          label="TEMPO"
          class="allibo-filter-job-time"
          filled
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4" md="4" xl="4">
        <v-select
          :items="availableProvinces"
          v-model="selectedProvince"
          @change="filterJobs"
          label="PROVINCIA"
          class="allibo-filter-job-provinces"
          filled
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row
      v-for="job in filteredJobs"
      class="allibo-job-wrapper"
      :key="job.id + Math.random()"
    >
      <v-col cols="0">
        <router-link
          :to="`/lavora-con-noi/${storeId}/${job.id}`"
          class="allibo-job"
        >
          <!-- {{ job.Job }}<br /> -->
          {{ job.title }} - {{ job.description }}</router-link
        >
      </v-col>
      <v-col
        cols="2"
        sm="1"
        class="d-flex flex-wrap justify-center align-center share"
      >
        <v-icon
          @click="copy(storeId, job.id)"
          large
          color="primary"
          class="copy"
        >
          $copy
        </v-icon>
        <v-icon
          class="d-sm-none wa"
          large
          color="primary"
          @click="shareOnWA(job.DetailLink)"
          >icon-whatsapp
        </v-icon>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else-if="!jobs && !loading"
    ><h4>
      Al momento non sono disponibili posizioni aperte per quest'area.
    </h4></v-container
  >
</template>
<style scoped lang="scss">
::v-deep .allibo-filters .v-input__slot {
  background: rgba(49, 46, 129, 0.2) !important;
}
.allibo-filters {
  margin-bottom: 16px;
}
.allibo-job {
  display: block;
  padding: 16px;
  border: 1px $primary solid;
  border-radius: 16px;
  box-shadow: 0 0 4px 1px $primary;
  // margin-bottom: 16px;
  text-decoration: none;
  font-weight: bold;
}

.share {
  .copy {
    @media #{map-get($display-breakpoints, 'xs-only')} {
      font-size: 24px !important;
      padding-bottom: 10px;
    }
  }
  .wa {
    @media #{map-get($display-breakpoints, 'xs-only')} {
      font-size: 24px !important;
    }
  }
}
</style>
<script>
import axios from "~/plugins/axios";
import cloneDeep from "lodash/cloneDeep";
// import get from "lodash/get";
export default {
  // props: {
  //   alliboDM: { type: String, required: true },
  //   alliboFT: { type: String, required: true },
  //   jobTimes: { type: String, required: true },
  //   jobTypes: { type: String, required: true }
  // },
  data() {
    return {
      jobs: null,
      filteredJobs: null,
      provinces: null,
      defaultType: "TUTTI",
      defaultTime: "TUTTI",
      defaultProvince: "TUTTE",
      selectedType: null,
      selectedTime: null,
      selectedProvince: null,
      loading: false
    };
  },
  components: {},
  computed: {
    availableJobTypes() {
      return [
        this.defaultType,
        ...[...new Set(this.jobs.map(job => job.title))]
      ];
    },
    availableJobTimes() {
      const availabilityMap = {};

      this.jobs.forEach(job => {
        const availability = job.details.time_availability;
        if (availability) {
          Object.values(availability).forEach(entry => {
            availabilityMap[entry.id] = entry.value;
          });
        }
      });

      return [this.defaultType, ...Object.values(availabilityMap)];
    },
    availableProvinces() {
      const provincesMap = {};

      this.jobs.forEach(job => {
        const provinces = job.details.loc.city;
        if (provinces) {
          Object.values(provinces).forEach(entry => {
            provincesMap[entry.id] = entry.value;
          });
        }
      });

      return [this.defaultProvince, ...Object.values(provincesMap)];
    }
    // storeId() {
    //   let result = get(this, "$route.meta.storeId", 1);
    //   return result;
    // }
  },
  methods: {
    async fetchJobs(selectedType, selectedTime, selectedProvince, storeId) {
      this.loading = true;
      // let url = `https://europe-west1-steps-c4a79.cloudfunctions.net/api/job-posts?regionId=${selectedProvince}&jobType=${selectedType}&time_availability=${selectedTime}`;
      if (selectedType === "TUTTI") {
        selectedType = "";
      }
      if (selectedTime === "TUTTI") {
        selectedTime = "";
      }
      if (selectedProvince === "TUTTE") {
        selectedProvince = "";
      }
      let url = `https://europe-west1-steps-c4a79.cloudfunctions.net/api/job-posts/?regionId=${selectedProvince}&time_availability=${selectedTime}`;
      return axios
        .get(url, {
          headers: {
            accept: "application/json",
            "x-api-key": process.env.VUE_APP_STEPSCONNECT_KEY
          }
        })
        .then(response => {
          let result = response.data.filter(res => {
            return (
              res?.custom_fields?.category === storeId &&
              res?.status === "published"
            );
          });
          if (result.length == 0) {
            this.loading = false;
            return null;
          }
          this.loading = false;
          return result;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    filterJobs() {
      let filtered = this.jobs;

      // Filter by role/type
      if (this.selectedType !== this.defaultType) {
        filtered = filtered.filter(job => job.title === this.selectedType);
      }

      // Filter by time
      if (this.selectedTime !== this.defaultTime) {
        filtered = filtered.filter(job => {
          const timeAvailability = job.details.time_availability;
          return Object.values(timeAvailability).some(
            time => time.value === this.selectedTime
          );
        });
      }

      // Filter by province
      if (this.selectedProvince !== this.defaultProvince) {
        filtered = filtered.filter(job => {
          const cities = job.details.loc.city;
          return Object.values(cities).some(
            city => city.value === this.selectedProvince
          );
        });
      }

      this.filteredJobs = filtered;
    },
    copy(storeId, jobId) {
      let detailLink =
        process.env.VUE_APP_EBSN_URL + `lavora-con-noi/${storeId}/${jobId}`;
      navigator.clipboard.writeText(detailLink);
    },
    shareOnWA(detailLink) {
      window.location.href = `https://api.whatsapp.com/send?text=${detailLink}`;
    }
  },
  async created() {
    this.selectedType = this.defaultType;
    this.selectedTime = this.defaultTime;
    this.selectedProvince = this.defaultProvince;
    this.storeId = this.$route.params.storeId;
    const data = await this.fetchJobs(
      this.selectedType,
      this.selectedTime,
      this.selectedProvince,
      this.storeId
    );
    this.jobs = data;
    this.filteredJobs = cloneDeep(this.jobs);
  }
};
</script>
